(function ($,_) {

  _.UI.extend('AddToDesktop', {
    init: function (box, options) {
      this.base(box, options);
      this.opt = $.extend({}, _.AddToDesktop.defaultOptions, this.opt);
      var ua = navigator.userAgent.toLowerCase();
      //uc
      if(~ua.indexOf('android') && ~ua.indexOf('ucbrowser')){
        this.contentHtml = '<p>点下方 “<i class="gag-ico-set1"></i>” 收藏网址<i class="gag-ico-to"></i>手机桌面，将17173添加到桌面</p>';
      }
      //qq
      else if(~ua.indexOf('android') && ~ua.indexOf('qqbrowser') && !~ua.indexOf('micromessenger')){
        this.contentHtml = '<p>点下方 “<i class="gag-ico-set1"></i>” 添加书签<i class="gag-ico-to"></i>桌面书签，将17173添加到桌面</p>';
      }
      //chrome
      else if(~ua.indexOf('android') && (/chrome\/[.0-9]*/).test(ua) && !~ua.indexOf("version")){
        this.contentHtml = '<p>点击右上方 “<i class="gag-ico-set2"></i>” 添加到主屏幕，将17173添加到桌面</p>';
      }
      //safari
      else if(~ua.indexOf('iphone') && ~ua.indexOf('safari') && !~ua.indexOf('CriOS')){
        this.contentHtml = '<p>点击下方 “<i class="gag-ico-set"></i>” 添加到主屏幕，将17173添加到桌面</p>';
      }
      else{
        return;
      }
      this.storageKey = 'addToDesktop';
      if(!localStorage.getItem('addToDesktop')){
        this.render();
        this.bindEvent();
      }
    },
    bindEvent:function(){
      var me = this;
      this.box.find('.gb-app-gamerss-closebox').on('click',function(){
        me.box.remove();
        localStorage.setItem('addToDesktop','true');
      });
    },
    render:function(){
      this.box.find('.gb-app-gamerss-txt').text('').append(this.contentHtml);
      this.box.show();
    }
  });

  _.AddToDesktop.defaultOptions = {
  };
})(jQuery,ue);